import { useQuery } from "@tanstack/react-query";
import { getSettings } from "@/lib/api";

// Public production origin used for canonical / SEO tags.
export const SITE_ORIGIN = "https://ankaradugunfotografi.com";

export const FALLBACK_SETTINGS = {
  brand_name: "Ankara Düğün Fotoğrafı",
  domain: "ankaradugunfotografi.com",
  phone: "+90 555 000 00 00",
  phone_raw: "+905550000000",
  whatsapp: "905550000000",
  email: "info@ankaradugunfotografi.com",
  instagram: "https://instagram.com/ankaradugunfotografi",
  address: "Ankara, Türkiye",
  map_query: "Ankara",
  whatsapp_default_message:
    "Merhaba, Ankara düğün fotoğraf çekimi hakkında bilgi almak istiyorum.",
  gallery: [],
};

export function useSettings() {
  const { data } = useQuery({
    queryKey: ["settings"],
    queryFn: getSettings,
    staleTime: 1000 * 60 * 30,
  });
  return data || FALLBACK_SETTINGS;
}

export function waLink(settings, message) {
  const s = settings || FALLBACK_SETTINGS;
  const msg = encodeURIComponent(message || s.whatsapp_default_message || "Merhaba");
  return `https://wa.me/${s.whatsapp}?text=${msg}`;
}

export function telLink(settings) {
  const s = settings || FALLBACK_SETTINGS;
  return `tel:${s.phone_raw || s.phone}`;
}
